export default __webpack_public_path__ + "static/media/appoinment.1ea328fa.jpg";